/**
 * Intuit.ts handles events that affect our integration with intuit SSO
 */
import router from '@/router/router'
import { store } from '@/store'
import AppSyncNotification from '@/types/AppSyncNotification.interface'

//  Create an object selector that points to the appropriate connection handler
const oauthCompleteHandler = {
    error(firstTime: boolean): void {
        store.dispatch('dialogOpen', {
            type: 'MESSAGE',
            title: `Can't Connect to QuickBooks.`,
            text: 'Oops, it looks like that QuickBooks Online company was already connected to one of your other sites.  For security and data integrity reasons, MessageDesk only allows one linked connection with a QuickBooks Online company.',
            icon: 'mdi-alert'
        })
        //  Set QBO Connection to false
        store.commit('qboConnectionSet', false)
    },
    app_setup(firstTime: boolean): void {
        //  Sync tenant data with qbo
        triggerSyncOrLoad(firstTime)

        //  Navigate to contacts, and see sync progress
        router.push('/contacts')
    },
    app_settings(firstTime: boolean): void {
        //  Sync tenant data with qbo
        triggerSyncOrLoad(firstTime)

        //  Navigate to qbo/sync, and see sync progress
        // router.push('/qbo')
    }
}

// A function used to trigger a QBO sync/load
const triggerSyncOrLoad = (firstTime: boolean): void => {
    //  Activate sync state
    store.commit('dataProviderSyncProgressSet', { message: 'Beginning Sync', percent: 0 })

    //  If this is the first sync...
    if (firstTime) {

        //  Load data from QBO
        store.dispatch('qboLoad')
    }

    //  Else, persons are still shown, dispatch qbo sync
    store.dispatch('qboSync')
}

const handlers = {
    async qboOauthComplete(notification: AppSyncNotification): Promise<void> {
        store.getters.appDebug && console.log('INTUIT: Qbo OAuth Complete', notification)

        //  Set QBO Connection
        store.commit('qboConnectionSet', true)

        //  Fetch our tenant now that we know we have a QBO tenant
        await store.dispatch('tenantGet', notification.tenant_id)

        //  Fetch the qbo customer count
        const count = await store.dispatch('qboCustomersCount')

        //  If the count is zero, we know it is the first time the tenant has connected
        const firstTime = (count === 0)

        //  Select the appropriate handler, dependent on the oauth_sender param
        const handler = oauthCompleteHandler[notification.oauthSender]

        //  If the handler exists, run it
        if (handler) handler(firstTime)

        //  Close app loading
        store.commit('splashSet', null)
    }
}

export default {
    onAppSyncNotificationReceived(notification: AppSyncNotification): void {
        //  Determine if we should hand this notification
        const handler = handlers[notification.event]

        //  If the handler exists, run it
        if (handler) handler(notification)
    },
    onUserLogout(): void {
        store.getters.appDebug && console.log('INTUIT: onUserLogout')

        //  Check if the tenant has a QBO account
        const hasQbo = store.getters.qboHasAccount

        //  If the tenant has a qbo account, signout of Intuit SSO
        if (hasQbo) store.dispatch('intuitLogout')
    }
}
